var _g, _path, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_4135_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 33.3333V17.7643C35.6237 18.1328 34.5018 18.3333 33.333 18.3333C31.5115 18.3333 29.8038 17.8463 28.333 16.9955V28.3333H24.9997V16.6667H27.8033C25.1088 14.8751 23.333 11.8116 23.333 8.33333C23.333 7.16455 23.5335 6.0426 23.902 5H4.99967C4.07921 5 3.33301 5.7462 3.33301 6.66667V33.3333C3.33301 34.2538 4.07921 35 4.99967 35H34.9997C35.9202 35 36.6663 34.2538 36.6663 33.3333ZM11.6663 21.6667H14.9997V28.3333H11.6663V21.6667ZM18.333 11.6667H21.6663V28.3333H18.333V11.6667Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4135_507",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 34,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6663 33.3333V17.7643C35.6237 18.1328 34.5018 18.3333 33.333 18.3333C31.5115 18.3333 29.8038 17.8463 28.333 16.9955V28.3333H24.9997V16.6667H27.8033C25.1088 14.8751 23.333 11.8116 23.333 8.33333C23.333 7.16455 23.5335 6.0426 23.902 5H4.99967C4.07921 5 3.33301 5.7462 3.33301 6.66667V33.3333C3.33301 34.2538 4.07921 35 4.99967 35H34.9997C35.9202 35 36.6663 34.2538 36.6663 33.3333ZM11.6663 21.6667H14.9997V28.3333H11.6663V21.6667ZM18.333 11.6667H21.6663V28.3333H18.333V11.6667Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4135_507)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_fn_4135_507)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.7702,
    cy: 35.0703,
    rx: 24.3611,
    ry: 39.1926,
    transform: "rotate(-44.9306 10.7702 35.0703)",
    fill: "url(#paint0_linear_4135_507)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_n_4135_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1107 14.4895L34.5217 13.5467C35.2542 11.8656 36.5736 10.5272 38.2199 9.79497L39.4859 9.23187C40.1706 8.92739 40.1706 7.93119 39.4859 7.6267L38.2907 7.09507C36.6021 6.34402 35.2591 4.95605 34.5391 3.21789L34.1171 2.19906C33.8231 1.48899 32.8424 1.48899 32.5482 2.19906L32.1262 3.21789C31.4064 4.95605 30.0634 6.34402 28.3747 7.09507L27.1794 7.6267C26.4949 7.93119 26.4949 8.92739 27.1794 9.23187L28.4456 9.79497C30.0919 10.5272 31.4112 11.8656 32.1437 13.5467L32.5546 14.4895C32.8554 15.1797 33.8101 15.1797 34.1107 14.4895Z",
    fill: "url(#paint1_linear_4135_507)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_4135_507",
    x: 3.33301,
    y: 5,
    width: 33.333,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_4135_507"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_fn_4135_507",
    x: -34.3477,
    y: -10.0825,
    width: 90.2354,
    height: 90.3057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25,
    result: "effect1_foregroundBlur_4135_507"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_foregroundBlur_4135_507",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_4135_507"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_foregroundBlur_4135_507"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_n_4135_507",
    x: 26.666,
    y: 1.6665,
    width: 13.333,
    height: 13.3408,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_4135_507"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4135_507",
    x1: 41.0486,
    y1: 24.8302,
    x2: 12.5398,
    y2: 37.8702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276417,
    stopColor: "#081681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583149,
    stopColor: "#0F9CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997BAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4135_507",
    x1: 33.3327,
    y1: 1.6665,
    x2: 33.3327,
    y2: 15.0072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC1503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseIcon);
export default __webpack_public_path__ + "static/media/caseIcon.d1e7e764c1ebcca35991bcf314d9c616.svg";
export { ForwardRef as ReactComponent };